
const NOMA_CARE_FINDER = window.NOMA_CARE_FINDER = {
  targetLabels: {
    chlamydia: 'Chlamydia',
    gonorrhoea: 'Gonorrhoea',
    trichomoniasis: 'Trichomoniasis',
    hiv: 'HIV',
    syphilis: 'Syphilis',
    hsv: 'Herpes / HSV',
    hpv: 'HPV',
    hepb: 'Hepatitis B',
    hepc: 'Hepatitis C',
    pregnancy: 'Pregnancy',
    psa: 'Prostate / PSA',
  },

  categoryLabels: {
    sexual: 'Sexual health and STI screening',
    pregnancy: 'Pregnancy and reproductive health',
    bloodborne: 'Blood-borne screening formats',
    prostate: 'Prostate and men’s health',
    bundles: 'Multi-target products',
    unsure: 'Browse by category',
  },

  formatLabels: {
    single: 'Focused single-target products',
    bundle: 'Broader multi-target products',
    compare: 'Focused and multi-target formats',
  },

  contextLabels: {
    routine: 'Routine product comparison',
    recent: 'Recent possible exposure',
    concern: 'Symptoms or a medical concern',
  },

  coverageGroups: {
    'common-sti': {
      label: 'Chlamydia and gonorrhoea',
      targets: ['chlamydia', 'gonorrhoea'],
    },
    bloodborne: {
      label: 'HIV, syphilis, hepatitis B and hepatitis C',
      targets: ['hiv', 'syphilis', 'hepb', 'hepc'],
    },
    'hiv-syphilis-herpes': {
      label: 'HIV, syphilis and herpes / HSV',
      targets: ['hiv', 'syphilis', 'hsv'],
    },
    'five-target': {
      label: 'HIV, syphilis, herpes / HSV, chlamydia and gonorrhoea',
      targets: ['hiv', 'syphilis', 'hsv', 'chlamydia', 'gonorrhoea'],
    },
    'compare-bundles': {
      label: 'All multi-target products',
      targets: [],
    },
  },

  categories: [
    {
      value: 'sexual',
      icon: 'STI',
      label: 'Sexual health and STI screening',
      copy: 'Compare focused and multi-target products by stated STI screening coverage.',
    },
    {
      value: 'pregnancy',
      icon: 'hCG',
      label: 'Pregnancy and reproductive health',
      copy: 'Compare the pregnancy-test product in the NomaCare catalogue.',
    },
    {
      value: 'bloodborne',
      icon: 'HIV',
      label: 'Blood-borne screening formats',
      copy: 'Compare published blood-borne screening formats by their stated coverage.',
    },
    {
      value: 'prostate',
      icon: 'PSA',
      label: 'Prostate and men’s health',
      copy: 'Compare the prostate-specific antigen screening product.',
    },
    {
      value: 'bundles',
      icon: '3+',
      label: 'Compare multi-target products',
      copy: 'Compare combination products by the targets they are stated to cover.',
    },
    {
      value: 'unsure',
      icon: 'ALL',
      label: 'I am not sure',
      copy: 'Browse the catalogue by health area instead of answering more questions.',
    },
  ],

  targetsByCategory: {
    sexual: [
      ['chlamydia', 'CT', 'Chlamydia', 'Focused and combination formats'],
      ['gonorrhoea', 'NG', 'Gonorrhoea', 'Focused and combination formats'],
      ['hiv', 'HIV', 'HIV', 'Focused and combination formats'],
      ['syphilis', 'SYP', 'Syphilis', 'Focused and combination formats'],
      ['hsv', 'HSV', 'Herpes / HSV', 'Focused and combination formats'],
      ['hpv', 'HPV', 'HPV', 'Focused catalogue product'],
    ],
    bloodborne: [
      ['hepb', 'HBV', 'Hepatitis B', 'Focused and combination formats'],
      ['hepc', 'HCV', 'Hepatitis C', 'Focused and combination formats'],
      ['hiv', 'HIV', 'HIV', 'Focused and combination formats'],
      ['syphilis', 'SYP', 'Syphilis', 'Focused and combination formats'],
    ],
  },

  collections: [
    ['All screening products', '/collections/all', 'Browse every currently published NomaCare screening product.'],
    ['Sexual health screening', '/collections/sexual-health', 'Browse current STI screening products and combination packs.'],
    ['Multi-target products', '/collections/bundles', 'Compare currently published combination products.'],
  ],
};

function parseJsonScript(root, selector) {
  const node = root.querySelector(selector);
  if (!node) return [];

  try {
    const value = JSON.parse(node.textContent.trim() || '[]');
    return Array.isArray(value) ? value : [];
  } catch (error) {
    console.error(`NomaCare Product Finder could not parse ${selector}.`, error);
    return [];
  }
}

const NOMA_CARE_TARGETS = new Set(Object.keys(NOMA_CARE_FINDER.targetLabels));

function cleanStringArray(value) {
  if (!Array.isArray(value)) return [];
  return [...new Set(value.map((item) => String(item).trim()).filter(Boolean))];
}

function normaliseProduct(product) {
  const handle = String(product.handle || '').trim();
  const numericPrice = Number(product.priceCents);
  const targets = cleanStringArray(product.targets).filter((target) => NOMA_CARE_TARGETS.has(target));
  const groups = cleanStringArray(product.groups);
  const rawTargetCount = Number(product.targetCount);
  const targetCount =
    Number.isFinite(rawTargetCount) && rawTargetCount > 0
      ? Math.max(targets.length, Math.round(rawTargetCount))
      : targets.length;

  return {
    handle,
    title: String(product.title || '').trim(),
    url: String(product.url || `/products/${handle}`),
    image: String(product.image || ''),
    imageAlt: String(product.imageAlt || product.title || 'NomaCare product'),
    priceCents: Number.isFinite(numericPrice) && numericPrice > 0 ? Math.round(numericPrice) : 0,
    currency: String(product.currency || 'ZAR'),
    available: product.available === true,
    targets,
    format: product.format === 'bundle' ? 'bundle' : 'single',
    targetCount,
    summary: String(product.summary || '').trim(),
    groups,
    packFormat: String(product.packFormat || 'Product format not specified').trim(),
  };
}

function prepareLiveProducts(products) {
  if (!Array.isArray(products)) return [];

  const catalogue = new Map();
  products.forEach((rawProduct) => {
    const product = normaliseProduct(rawProduct);
    if (!product.handle || !product.title || product.targets.length === 0) return;
    catalogue.set(product.handle, product);
  });

  return [...catalogue.values()];
}

function hasValidPrice(product) {
  return Number.isFinite(product?.priceCents) && product.priceCents > 0;
}

function productFormatLabel(product) {
  if (product?.format !== 'bundle') return 'Focused product';

  return product.packFormat.toLowerCase().includes('one cassette')
    ? 'Multi-target product'
    : 'Multi-target kit';
}

function formatMoney(cents, currency = 'ZAR') {
  const numericCents = Number(cents);
  if (!Number.isFinite(numericCents) || numericCents <= 0) return '';

  const amount = numericCents / 100;

  if (currency === 'ZAR') {
    return `R${amount.toLocaleString('en-ZA', {
      minimumFractionDigits: Number.isInteger(amount) ? 0 : 2,
      maximumFractionDigits: 2,
    })}`;
  }

  return new Intl.NumberFormat('en-ZA', {
    style: 'currency',
    currency,
    maximumFractionDigits: 2,
  }).format(amount);
}

function joinNatural(items) {
  if (items.length === 0) return '';
  if (items.length === 1) return items[0];
  if (items.length === 2) return `${items[0]} and ${items[1]}`;
  return `${items.slice(0, -1).join(', ')}, and ${items.at(-1)}`;
}

window.NomaCareFinderHelpers = {
  parseJsonScript,
  normaliseProduct,
  prepareLiveProducts,
  hasValidPrice,
  productFormatLabel,
  formatMoney,
  joinNatural,
};
